import { setVar } from "../events"
import { toBoolean, toNumber } from "../vars"

const SCHEMAS = { text: { type: "string" }, number: { type: "number" }, boolean: { type: "boolean" }, enum: { type: "string" } }

// One tool per declared var. The value is checked against the declared type before it is written, and the
// model reads the error when it is not, so it can try again in the same turn
export function captureTools(item: PlaybookItem): PlaybookTool[] {
  return (item.captures || []).filter(c => c.var).map(capture => ({
    name: `save_${capture.var.replace(/[^a-zA-Z0-9_]/g, "_")}`,
    description: capture.description,
    parameters: {
      type: "object",
      properties: { value: capture.type === "enum" ? { type: "string", enum: capture.values || [] } : SCHEMAS[capture.type] },
      required: ["value"],
    },
    run: async ({ value }, run) => {
      const typed = coerce(capture, value)
      if (typed === undefined) return `Not saved: expected ${capture.type === "enum" ? `one of ${(capture.values || []).join(", ")}` : `a ${capture.type}`}`
      await setVar(run, capture.var, typed)
      return "Saved."
    },
  }))
}

function coerce(capture: PlaybookCapture, value: any): any {
  if (capture.type === "number") return toNumber(value)
  if (capture.type === "boolean") return toBoolean(value)
  if (capture.type === "enum") return (capture.values || []).find(v => v.toLowerCase() === String(value).trim().toLowerCase())
  return typeof value === "string" && value.trim() ? value : undefined
}
